// Not found component

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { utils } from '../../devUtils';


import ErrorImage from '../../assets/images/404.png';
import Button from '../../components/Button';
import { LINK_HOME } from '../../devUtils/constants';

const NOT_FOUND_UI = () => {
  return (
    <div className="text-center">
      <h1 className="text-center error-page">
        <img src={ErrorImage} alt="" />
        <br />Page not found
      </h1>
      <Link to={LINK_HOME} style={{ paddingRight: '0px' }}>
        <Button type="primary">Take me home</Button>
      </Link>
    </div>);
};

function NotFound({ location = {}, staticContext = {} }) {
  // Add notFound true to staticContext
  // Note: staticContext object will be null in client side rendering.
  // staticContext is only available in server side rendering.
  // So we are initializing it to {}
  // console.log(props);
  // utils.isRedirectedReq(location);
  // staticContext.notFound = true; // eslint-disable-line no-param-reassign
  // return (<div className="text-center"><h1 className="text-center error-page"><img src={ErrorImage} alt="" /> <br />Page not found </h1><Link to={LINK_HOME} style={{ paddingRight: '0px' }}><Button type="primary">Take me home</Button></Link></div>);
  // return NOT_FOUND_UI();
  staticContext.notFound = true; // eslint-disable-line no-param-reassign
  if (utils.isRedirectedReq(location)) {
    return NOT_FOUND_UI();
  }
  return '';
}

NotFound.propTypes = {
  staticContext: PropTypes.object,
  location: PropTypes.object,
};

export default NotFound;



// WEBPACK FOOTER //
// client/components/NotFound/index.js